import { render, staticRenderFns } from "./BubenzorwegLogo.vue?vue&type=template&id=e2d2cddc&scoped=true&"
var script = {}
import style0 from "./BubenzorwegLogo.vue?vue&type=style&index=0&id=e2d2cddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d2cddc",
  null
  
)

export default component.exports